
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/migrate-from-okta",
      function () {
        return require("private-next-pages/learn/migrate-from-okta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/migrate-from-okta"])
      });
    }
  